import axios from 'axios';

// Empty = same origin (the Pages proxy forwards /api and /auth to the Worker).
const API_BASE = process.env.REACT_APP_API_URL !== undefined ? process.env.REACT_APP_API_URL : '';

const apiClient = axios.create({
  baseURL: API_BASE,
  headers: { 'Content-Type': 'application/json' },
  withCredentials: true,
});

apiClient.interceptors.response.use(
  (res) => res,
  async (error) => {
    if (error.response && error.response.status === 401 && window.location.pathname !== '/login') {
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

const AUTH_BASE = API_BASE;

export { apiClient, AUTH_BASE };
